import React, { useState, useRef } from 'react';

const CashbotInput = ({ onSendMessage, disabled, context = 'admin' }) => {
  const [message, setMessage] = useState('');
  const inputRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim() && !disabled) {
      onSendMessage(message.trim());
      setMessage('');

      if(inputRef.current) {
        inputRef.current.style.height = '40px'; // Reset height
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  // Different suggested queries based on context
  const adminSuggestedQueries = [
    "Show me user statistics",
    "What's the revenue this month?",
    "Create a user growth chart",
    "Show active subscriptions",
    "Analytics for last 30 days"
  ];
  
  const userSuggestedQueries = [
    "pie chart showing my monthly expenses",
    "Analyze my investment portfolio",
    "Create a Chart for Tracking my savings goals",
    "Create a budget tracker",
    "What's my spending pattern?",
    "Analyze my income sources",
    "Compare expenses to budget",
    "View my account summary"
  ];
  
  // Select the appropriate queries based on context
  const suggestedQueries = context === 'admin' ? adminSuggestedQueries : userSuggestedQueries;

  return (
    <div className="p-4">
      {/* Suggested Queries */}
      {message === '' && (
        <div className="mb-3">
          <p className="text-xs text-gray-500 mb-2">Suggested queries:</p>
          <div className="flex flex-wrap gap-1">
            {suggestedQueries.slice(0, 3).map((query, index) => (
              <button
                key={index}
                onClick={() => setMessage(query)}
                className="text-xs bg-gray-100 hover:bg-gray-200 text-gray-600 px-2 py-1 rounded-full transition-colors"
              >
                {query}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Input Form */}
      <form onSubmit={handleSubmit} className="flex space-x-2">
        <div className="flex-1 relative">
          <textarea
            ref={inputRef}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder={context === 'admin' ? "Ask Admin CashBot" : "Ask CashBot"}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-btn-primary focus:border-transparent text-sm"
            rows="1"
            disabled={disabled}
            style={{ minHeight: '38px', maxHeight: '100px' }}
            onInput={(e) => {
              e.target.style.height = 'auto';
              e.target.style.height = Math.min(e.target.scrollHeight, 100) + 'px';
            }}
          />
        </div>
        <button
          type="submit"
          disabled={!message.trim() || disabled}
          className="h-10 px-3 bg-btn-primary text-white rounded-lg hover:bg-btn-primary-hover disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center"
        >
          {disabled ? (
            <svg className="w-4 h-3 animate-spin" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          ) : (
            <svg className="w-4 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
            </svg>
          )}
        </button>
      </form>
    </div>
  );
};

export default CashbotInput;